import axiosClient from "../../../../system/helpers/axiosConfig";

export const postProgram = (params) => {
  return axiosClient
    .post(`api/admin/programs/update`, params)
    .then((r) => r.data.data);
};
